import {FormGenContainer, FormGenContainerMode, FormGenContentItem, FormGenLayoutSource} from "./FormGenContainer";
import React, {ReactElement, useEffect, useState} from "react";
import {StyledBoxColumn, StyledBoxRow, StyledSpan} from "./StyledComponents";
import {Button, Card, Typography} from "@mui/material";
import {PD_LG, PD_MD} from "./dimens";
import {CheckOutlined, CloseOutlined, EditOutlined} from "@mui/icons-material";
import {lightGray} from "./colors";
import {md5_uuid} from "./md5";

function FormGenArrayObjectItem({index, array, setArray}: {
  index: number,
  array: any[],
  setArray: (array: any[]) => void
}): ReactElement {
  const [editing, setEditing] = useState<boolean>(false);
  return <Card>
    <StyledBoxColumn style={{gap: 0}}>
      <StyledBoxRow
        style={{padding: PD_MD, alignItems: "center"}}>
        <StyledSpan/>
        {!editing
          ? <>
            <Button
              color="error"
              startIcon={<CloseOutlined/>}
              onClick={() => setArray([...array.slice(0, index), ...array.slice(index + 1)])}>
              Remove
            </Button>
            <Button
              startIcon={<EditOutlined/>}
              onClick={() => setEditing(true)}>
              Edit
            </Button>
          </>
          : null}
        {editing
          ? <>
            <Button
              onClick={() => setEditing(false)}>
              Done
            </Button>
          </>
          : null}
      </StyledBoxRow> <FormGenContainer
      key={`formgen-array-object-${index}`}
      content={array[index]}
      mode={editing ? FormGenContainerMode.EDIT : FormGenContainerMode.READ}
    />
    </StyledBoxColumn>
  </Card>;
}

export function FormGenArrayObject(props: {
  contentItem: FormGenContentItem,
  index: number,
  source: FormGenLayoutSource,
}): ReactElement {
  const contentItem = props.contentItem;
  const [array, setArray] = useState<any[]>((props.source.getValue(contentItem) as Array<any>) || []);
  const [add, setAdd] = useState<any>(contentItem.metadata.arrayObjectCreator());
  const [addKey, setAddKey] = useState<string>(md5_uuid());
  const [addEnabled, setAddEnabled] = useState<boolean>();
  useEffect(() => {
    props.source.setValue(props.contentItem, array);
  }, [array]);
  return <StyledBoxColumn>
    {array?.length > 0
      ? array.map((_, index) => <FormGenArrayObjectItem index={index} array={array} setArray={setArray}/>)
      : <Typography variant={"body2"} style={{textAlign: "center", padding: PD_MD}}><i>List is empty</i></Typography>
    }
    <StyledBoxColumn style={{marginTop: PD_MD, marginBottom: PD_MD, padding: PD_LG, background: lightGray}}>
      <FormGenContainer
        key={`formgen-array-object-add-${addKey}`}
        style={{flexGrow: 1}}
        content={add}
        onContainerRequiredItemsFilledChanged={(container, filled) => setAddEnabled(filled)}
      />
      <StyledBoxRow style={{alignItems: "center", padding: PD_MD}}>
        <Typography variant={"body2"}>Click the "Add" button to add this item to the list.</Typography>
        <StyledSpan/>
        <Button
          disabled={!addEnabled}
          variant={"contained"}
          startIcon={<CheckOutlined/>}
          onClick={() => {
            setArray([...array, add]);
            setAdd(contentItem.metadata.arrayObjectCreator());
            setAddKey(md5_uuid());
          }}>
          Add
        </Button>
      </StyledBoxRow>
    </StyledBoxColumn>
  </StyledBoxColumn>
}